import { useEffect, useRef } from 'react';
import ValuationForm, { type ValuationFormProps } from '@/components/valuation/ValuationForm';
import valuationCopy from '@/data/translations/ro/valuation.json';
import { trackSellValuationView } from '@/utils/buyerJourneyTracking';

/** RO-only valuation block shown above the paid packages on /vinde-masina. */
export default function SellValuationCard({
  initial,
  initialKey,
  onResult,
  onPublish,
}: Pick<ValuationFormProps, 'initial' | 'onResult' | 'onPublish'> & { initialKey: string }) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        trackSellValuationView();
        io.disconnect();
      }
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section ref={ref} aria-labelledby="sell-valuation-heading" className="mb-10 min-h-[380px]">
      <h2 id="sell-valuation-heading" className="font-serif text-2xl md:text-3xl text-foreground">
        {valuationCopy.sell_card_heading}
      </h2>
      <p className="mt-2 mb-4 text-sm text-muted-foreground">{valuationCopy.sell_card_intro}</p>
      <ValuationForm key={initialKey} context="vinde" initial={initial} onResult={onResult} onPublish={onPublish} />
      <div className="mt-3 text-center">
        <a
          href="#sell-packages"
          className="text-sm text-primary underline underline-offset-4"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('sell-packages')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
        >
          {valuationCopy.sell_skip_link}
        </a>
      </div>
    </section>
  );
}
